module.exports = __webpack_public_path__ + "media/images/sources-b5fc2e105beace88232f839577f8896d.svg";